import iziToast from "izitoast";
import { playNotificationSound } from "./notificationSound";

export function getNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
}

export function requestNotificationPermission() {
  if (getNotificationPermission() === "unsupported") {
    return Promise.resolve("unsupported");
  }

  if (Notification.permission === "granted" || Notification.permission === "denied") {
    return Promise.resolve(Notification.permission);
  }

  return Notification.requestPermission();
}

export function isTabInBackground() {
  return typeof document !== "undefined" && document.hidden;
}

export function showOrderToast({ title, body, orderId, router, viewLabel }) {
  const buttons = orderId
    ? [
        [
          `<button type="button">${viewLabel}</button>`,
          function (instance, toast) {
            router.push(`/orders/show/${orderId}`);
            instance.hide({ transitionOut: "fadeOut" }, toast);
          },
          true,
        ],
      ]
    : [];

  iziToast.show({
    class: "order-notification-toast",
    theme: "light",
    icon: "ico-success",
    iconColor: "#007460",
    title: String(title || ""),
    message: String(body || ""),
    position: "bottomRight",
    timeout: 10000,
    progressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    resetOnHover: true,
    zindex: 99999,
    layout: 2,
    buttons,
  });
}

export function showBrowserNotification({ title, body, tag, onClick }) {
  if (getNotificationPermission() !== "granted") {
    return null;
  }

  const notification = new Notification(String(title || ""), {
    body: String(body || ""),
    icon: "/favicon.ico",
    tag,
    requireInteraction: false,
    silent: true,
  });

  notification.onclick = () => {
    window.focus();
    if (typeof onClick === "function") {
      onClick();
    }
    notification.close();
  };

  return notification;
}

/**
 * In-app toast always; OS notification when tab is in background; sound always.
 */
export function showOrderAlert({
  router,
  viewLabel,
  title,
  body,
  orderId,
  playSound,
}) {
  const safeTitle = String(title || "New order");
  const safeBody = String(body || "");

  showOrderToast({
    title: safeTitle,
    body: safeBody,
    orderId,
    router,
    viewLabel,
  });

  if (isTabInBackground() && getNotificationPermission() === "granted") {
    showBrowserNotification({
      title: safeTitle,
      body: safeBody,
      tag: orderId ? `order-${orderId}` : "branch-order",
      onClick: () => {
        if (orderId) {
          router.push(`/orders/show/${orderId}`);
        }
      },
    });
  }

  if (typeof playSound === "function") {
    playSound();
  } else {
    playNotificationSound();
  }
}
